export default __webpack_public_path__ + "static/how_1-05c15c6b01b1eb9333efae464ae961da.png";